module.exports = __webpack_public_path__ + "static/media/undraw_journey.5c4acff1.svg";